import React, { useState } from 'react';
import { MultiSelect } from '../ui/MultiSelect';
import { Eye } from 'lucide-react';
import { Modal } from '../ui/Modal';
export function EventFeesTab() {
  const [selectedEventFees, setSelectedEventFees] = useState<string[]>([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewModalContent, setViewModalContent] = useState<any>(null);
  const eventFeeOptions = [{
    value: 'FEE-SMS-001',
    label: 'Standard SMS Fee'
  }, {
    value: 'FEE-SMS-002',
    label: 'SMS Fee for High Profile Product'
  }, {
    value: 'FEE-MAINT-001',
    label: 'Monthly Maintenance Fee'
  }, {
    value: 'FEE-MAINT-002',
    label: 'Annual Maintenance Fee'
  }, {
    value: 'FEE-DISB-001',
    label: 'First Disbursement Fee'
  }, {
    value: 'FEE-NOTIF-001',
    label: 'Email Notification Fee'
  }, {
    value: 'FEE-STMT-001',
    label: 'Statement Generation Fee'
  }];
  // Mock event fee details
  const eventFeeDetails: Record<string, any> = {
    'FEE-SMS-001': {
      name: 'Standard SMS Fee',
      code: 'FEE-SMS-001',
      feeEvent: 'SMS Charges',
      type: 'Fixed',
      amount: 'PKR 5',
      glAccount: 'GL-4200 - Event Fee Income',
      recurring: 'No',
      status: 'Active',
      effectiveDate: '2024-01-01'
    },
    'FEE-SMS-002': {
      name: 'SMS Fee for High Profile Product',
      code: 'FEE-SMS-002',
      feeEvent: 'SMS Charges',
      type: 'Fixed',
      amount: 'PKR 10',
      glAccount: 'GL-4200 - Event Fee Income',
      recurring: 'No',
      status: 'Active',
      effectiveDate: '2024-01-01'
    },
    'FEE-MAINT-001': {
      name: 'Monthly Maintenance Fee',
      code: 'FEE-MAINT-001',
      feeEvent: 'Maintenance Fees',
      type: 'Fixed',
      amount: 'PKR 100',
      glAccount: 'GL-4300 - Service Charges',
      recurring: 'Yes',
      recurringFrequency: 'Monthly',
      status: 'Active',
      effectiveDate: '2024-01-01'
    },
    'FEE-MAINT-002': {
      name: 'Annual Maintenance Fee',
      code: 'FEE-MAINT-002',
      feeEvent: 'Maintenance Fees',
      type: 'Fixed',
      amount: 'PKR 1000',
      glAccount: 'GL-4300 - Service Charges',
      recurring: 'Yes',
      recurringFrequency: 'Yearly',
      status: 'Active',
      effectiveDate: '2024-01-01'
    },
    'FEE-DISB-001': {
      name: 'First Disbursement Fee',
      code: 'FEE-DISB-001',
      feeEvent: 'First Disbursement Fees',
      type: 'Percentage',
      amount: '1%',
      glAccount: 'GL-4100 - Fee Income',
      recurring: 'No',
      status: 'Active',
      effectiveDate: '2024-01-01'
    },
    'FEE-NOTIF-001': {
      name: 'Email Notification Fee',
      code: 'FEE-NOTIF-001',
      feeEvent: 'SMS Charges',
      type: 'Fixed',
      amount: 'PKR 3',
      glAccount: 'GL-4200 - Event Fee Income',
      recurring: 'No',
      status: 'Active',
      effectiveDate: '2024-01-01'
    },
    'FEE-STMT-001': {
      name: 'Statement Generation Fee',
      code: 'FEE-STMT-001',
      feeEvent: 'Maintenance Fees',
      type: 'Fixed',
      amount: 'PKR 50',
      glAccount: 'GL-4300 - Service Charges',
      recurring: 'Yes',
      recurringFrequency: 'Monthly',
      status: 'Active',
      effectiveDate: '2024-01-01'
    }
  };
  const handleViewEventFee = (feeId: string) => {
    if (eventFeeDetails[feeId]) {
      setViewModalContent(eventFeeDetails[feeId]);
      setViewModalOpen(true);
    }
  };
  return <div className="space-y-8 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-619">
      <div className="space-y-6" data-id="element-620">
        <div data-id="element-621">
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-622">
            Event Fee Configuration
          </h3>
          <p className="text-sm text-gray-500" data-id="element-623">
            Select event-based fees that will be applicable to this loan
            product. Event fees are triggered by specific actions or milestones.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-624">
          <MultiSelect label="Applicable Event Fees" value={selectedEventFees} onChange={setSelectedEventFees} options={eventFeeOptions} placeholder="Select event fees to apply to this product..." data-id="element-625" />

          {selectedEventFees.length > 0 && <>
              <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-626">
                <div className="flex items-start" data-id="element-627">
                  <div className="flex-shrink-0" data-id="element-628">
                    <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor" data-id="element-629">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" data-id="element-630" />
                    </svg>
                  </div>
                  <div className="ml-3" data-id="element-631">
                    <h4 className="text-sm font-medium text-blue-900" data-id="element-632">
                      {selectedEventFees.length} Event Fee
                      {selectedEventFees.length !== 1 ? 's' : ''} Selected
                    </h4>
                    <p className="text-sm text-blue-700 mt-1" data-id="element-633">
                      These fees will be automatically applied when their
                      corresponding events occur during the loan lifecycle.
                    </p>
                  </div>
                </div>
              </div>

              {/* Selected Fees List with View Icons */}
              <div className="mt-4 space-y-2" data-id="element-634">
                <h4 className="text-sm font-medium text-gray-700" data-id="element-635">
                  Selected Event Fees:
                </h4>
                <div className="space-y-2" data-id="element-636">
                  {selectedEventFees.map(feeId => {
                const fee = eventFeeOptions.find(opt => opt.value === feeId);
                return <div key={feeId} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-637">
                        <span className="text-sm text-gray-900" data-id="element-638">
                          {fee?.label}
                        </span>
                        <button onClick={() => handleViewEventFee(feeId)} className="p-1.5 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors" title="View fee details" data-id="element-639">
                          <Eye className="h-4 w-4" data-id="element-640" />
                        </button>
                      </div>;
              })}
                </div>
              </div>
            </>}
        </div>

        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-641">
          <h4 className="text-sm font-medium text-gray-900 mb-3" data-id="element-642">
            Event Fee Types
          </h4>
          <div className="space-y-2 text-sm text-gray-600" data-id="element-643">
            <div className="flex items-start" data-id="element-644">
              <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-645"></span>
              <span data-id="element-646">
                <strong data-id="element-647">SMS Fees:</strong> Charged when SMS notifications are
                sent to customers
              </span>
            </div>
            <div className="flex items-start" data-id="element-648">
              <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-649"></span>
              <span data-id="element-650">
                <strong data-id="element-651">Maintenance Fees:</strong> Recurring fees charged at
                specified intervals
              </span>
            </div>
            <div className="flex items-start" data-id="element-652">
              <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-653"></span>
              <span data-id="element-654">
                <strong data-id="element-655">Disbursement Fees:</strong> One-time fees charged at
                loan disbursement
              </span>
            </div>
            <div className="flex items-start" data-id="element-656">
              <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-657"></span>
              <span data-id="element-658">
                <strong data-id="element-659">Notification Fees:</strong> Charged for email or other
                notification services
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* View Details Modal */}
      {viewModalContent && <Modal isOpen={viewModalOpen} onClose={() => setViewModalOpen(false)} title="Event Fee Profile Details" data-id="element-660">
          <div className="space-y-4" data-id="element-661">
            <div className="grid grid-cols-2 gap-4" data-id="element-662">
              <div data-id="element-663">
                <label className="text-sm font-medium text-gray-700" data-id="element-664">
                  Name
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-665">
                  {viewModalContent.name}
                </p>
              </div>
              <div data-id="element-666">
                <label className="text-sm font-medium text-gray-700" data-id="element-667">
                  Code
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-668">
                  {viewModalContent.code}
                </p>
              </div>
              <div data-id="element-669">
                <label className="text-sm font-medium text-gray-700" data-id="element-670">
                  Fee Event
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-671">
                  {viewModalContent.feeEvent}
                </p>
              </div>
              <div data-id="element-672">
                <label className="text-sm font-medium text-gray-700" data-id="element-673">
                  Type
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-674">
                  {viewModalContent.type}
                </p>
              </div>
              <div data-id="element-675">
                <label className="text-sm font-medium text-gray-700" data-id="element-676">
                  Amount
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-677">
                  {viewModalContent.amount}
                </p>
              </div>
              <div data-id="element-678">
                <label className="text-sm font-medium text-gray-700" data-id="element-679">
                  GL Account
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-680">
                  {viewModalContent.glAccount}
                </p>
              </div>
              <div data-id="element-681">
                <label className="text-sm font-medium text-gray-700" data-id="element-682">
                  Recurring
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-683">
                  {viewModalContent.recurring}
                </p>
              </div>
              {viewModalContent.recurring === 'Yes' && <div data-id="element-684">
                  <label className="text-sm font-medium text-gray-700" data-id="element-685">
                    Frequency
                  </label>
                  <p className="text-sm text-gray-900 mt-1" data-id="element-686">
                    {viewModalContent.recurringFrequency}
                  </p>
                </div>}
              <div data-id="element-687">
                <label className="text-sm font-medium text-gray-700" data-id="element-688">
                  Status
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-689">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-690">
                    {viewModalContent.status}
                  </span>
                </p>
              </div>
              <div data-id="element-691">
                <label className="text-sm font-medium text-gray-700" data-id="element-692">
                  Effective Date
                </label>
                <p className="text-sm text-gray-900 mt-1" data-id="element-693">
                  {viewModalContent.effectiveDate}
                </p>
              </div>
            </div>
          </div>
        </Modal>}
    </div>;
}